import React from 'react'
import { withStyles } from '@material-ui/core'
import { Table, TableBody, TableCell, TableHead, TableRow, TableFooter } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { currency } from '../../../../../helpers'
import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 700,
    },
    bgBlack: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        border: 'solid 1px lightgrey',
    },
    bgBlueGrey: {
        backgroundColor: '#424242',
        color: theme.palette.common.white,
        border: 'solid 1px lightgrey',
    },
    bgWhite: {
        border: '1px solid #ffffff',
    },
    bgLightBlue: {
        backgroundColor: '#dbe5f1',
        color: theme.palette.common.black,
        border: '1px solid white',
    },
    bgLightGreen: {
		backgroundColor: '#6fcdb3',
		color: theme.palette.common.black,
		border: '1px solid white',
	},
    noBorder: {
        border: '0px !important',
    },
    emptyRow: {
        height: '40px !important',
    },
    leftJustified: {
        textAlign: 'left !important',
    },
    reportTableContainer: {
        width: '500px',
        paddingBottom: '15px'
    },
    salaryCell: {
        paddingRight: '7px !important',
        textAlign: 'right !important'
	},
	alignLeft: {
		textAlign: 'left !important',
	},
}))

const StyledTableCell = withStyles(theme => ({
    head: {
        padding: theme.spacing(1),
        fontSize: 12,
        border: 'solid 1px lightgrey',
        textAlign: 'center',
        whiteSpace: 'nowrap',
    },
    body: {
        fontSize: 11,
        textAlign: 'center',
        whiteSpace: 'nowrap',
    },
    footer: {
		textAlign: 'center',
	},
}))(TableCell)

const StyledTableRow = withStyles(theme => ({
    root: {
        height: 'auto',
    },
}))(TableRow)


export default function CurrentAverageCostOfLaborSummaryReport(props) {

    const classes = useStyles()

    return (
        <div className={classes.reportTableContainer}>
            <Table id="CurrentAverageCostOfLaborSummaryReport" className={classes.reportTable} size="small">
                <TableHead>
                    <TableRow>
						<StyledTableCell colSpan={3} className={clsx(classes.noBorder, classes.alignLeft)}>
							{`Currency: ${props.currencyCode}`}
						</StyledTableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell className={clsx(classes.bgBlack, classes.noBorder)}>
                            Global Grade
						</StyledTableCell>
                        <StyledTableCell className={classes.noBorder}></StyledTableCell>

                        <StyledTableCell className={classes.bgBlueGrey}>
                            n
                        </StyledTableCell>
                        <StyledTableCell className={classes.bgBlueGrey}>
                            Actual Cost($)
                        </StyledTableCell>
                        <StyledTableCell className={classes.bgBlueGrey}>
                            Actual Cost(%)
                        </StyledTableCell>
                        <StyledTableCell className={classes.bgBlueGrey}>
                            Average Cost
                        </StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        props.levelsData.map((levelData, i) => {
                            return (
                                <StyledTableRow key={i}>
                                    <StyledTableCell className={classes.bgBlack}>
                                        {i}
                                    </StyledTableCell>
                                    <StyledTableCell className={classes.noBorder}></StyledTableCell>
                                    {
                                        Object.keys(props.groupSummary[i].current).map(value => {
                                            return (
                                                <React.Fragment key={`${i}${value}`}>
                                                    {value === "salarySummary" || value === "actualCostSummary" ?
                                                        <StyledTableCell className={clsx(classes.bgWhite, classes.salaryCell)}>
                                                            {currency(props.groupSummary[i].current[value], props.currencyCode)}
                                                        </StyledTableCell> :
                                                        <StyledTableCell align="left" className={classes.bgWhite}>
                                                            {props.groupSummary[i].current[value]}
                                                        </StyledTableCell>
                                                    }
                                                </React.Fragment>
                                            )
                                        })
                                    }
                                    <StyledTableCell className={classes.noBorder}></StyledTableCell>
                                </StyledTableRow>
                            )
                        })
                    }
                    {/* <StyledTableRow>
						<StyledTableCell className={classes.noBorder}></StyledTableCell>
						{
							groups.map(group =>
								<React.Fragment key={group}>
									<StyledTableCell className={classes.noBorder} colSpan={2}></StyledTableCell>
									<StyledTableCell className={classes.bgLightBlue}>
										{get(groupSummary[group],'n', '')}
									</StyledTableCell>
								</React.Fragment>
							)
						}
					</StyledTableRow> */}
                    <StyledTableRow>
                        <StyledTableCell className={classes.noBorder}></StyledTableCell>
                    </StyledTableRow>
                </TableBody>
                <TableFooter>
                    <StyledTableRow>
                        <StyledTableCell colSpan={1} className={classes.bgLightGreen}>Total {props.groupTotal.current.totalN}</StyledTableCell>
                        <StyledTableCell colSpan={1} className={classes.noBorder}></StyledTableCell>
                        <StyledTableCell className={classes.bgLightGreen}>
                            {props.groupTotal.current.totalN}
                        </StyledTableCell>
                        <StyledTableCell className={clsx(classes.bgLightGreen, classes.salaryCell)}>
                            {currency(props.groupTotal.current.totalActualCost,  props.currencyCode)}
                        </StyledTableCell>
                        <StyledTableCell className={classes.bgLightGreen}>
                            {props.groupTotal.current.totalPercent}
                        </StyledTableCell>
                        <StyledTableCell className={clsx(classes.bgLightGreen, classes.salaryCell)}>
                            {currency(props.groupTotal.current.totalSalary)}
                        </StyledTableCell>
                    </StyledTableRow>
                </TableFooter>
            </Table>
        </div>
    )
}
